import { FunctionComponent } from "react";
import PandoraPage from "../../components/PandoraPage/PandoraPage";
import styles from "./Error.module.css";
import { Title } from "@fyrstain/fhir-front-library";
import i18n from "i18next";
import { toPublicUrl } from "src/services/PublicUrl";

const Error: FunctionComponent = () => {

    return <PandoraPage loading={false} needsLogin={false} >
        <div className={styles.mainErrorContainer}>
            <img
                className={styles.imageIcon}
                src={toPublicUrl("/assets/oops.png")}
                alt="Oops !"
            />
            <Title level={1} prefix={i18n.t('title.error.oops')} content={i18n.t('title.error.problem')} />
        </div>
    </PandoraPage>
};

export default Error;
